import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useLang } from "@/lib/lang";

export const WaitlistToast = () => {
  const { t } = useLang();
  const [params, setParams] = useSearchParams();
  const status = params.get("waitlist");

  useEffect(() => {
    if (!status) return;
    const map = { confirmed: ["success", t.waitlist.confirmed], unsubscribed: ["message", t.waitlist.unsubscribed], invalid: ["error", t.waitlist.invalidLink] };
    const [kind, text] = map[status] || [];
    if (text) setTimeout(() => toast[kind](text), 1400);
    params.delete("waitlist");
    setParams(params, { replace: true });
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
